import { Component, inject, OnInit, input } from '@angular/core';

import { NgxQrcodeStylingModule, Options } from 'ngx-qrcode-styling';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { hugeCancel01 } from '@ng-icons/huge-icons';

@Component({
  selector: 'ui-qrcode',
  imports: [NgxQrcodeStylingModule, NgIconComponent],
  templateUrl: './qrcode.component.html',
  viewProviders: [
    provideIcons({
      hugeCancel01,
    }),
  ],
})
export class QrcodeComponent implements OnInit {
  private dialogRef = inject<DialogRef<string>>(DialogRef);

  readonly cardNumber = input.required<string | undefined>();
  readonly height = input.required<number>();
  readonly width = input.required<number>();
  data = inject(DIALOG_DATA);
  config!: Options;

  ngOnInit() {
    this.initQrcode();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  initQrcode() {
    this.config = {
      width: this.width() || 250,
      height: this.height() || 250,
      margin: 5,
      data: `member:${this.cardNumber() || this.data.cardNumber}`,
      dotsOptions: {
        color: '#000000',
        type: 'dots',
      },
      backgroundOptions: {
        color: '#ffffff',
      },
      imageOptions: {
        crossOrigin: 'anonymous',
        margin: 0,
      },
    };
  }
}
